import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Dashboard from '../../containers/Dashboard'
import Creatives from '../../features/Creatives'
import News from '../../features/News'
import LegalTexts from '../../containers/LegalTexts'
import SideContainer from '../../containers/SideContainer'
import styles from './main-section.scss'
import ServerMenu from '../../features/ServerMenu'

function JoinClassNames(array) {
    return array.join(' ')
}

class MainSection extends Component {
    shouldComponentUpdate(nextProps) {
        if (nextProps.layout !== this.props.layout) {
            // console.log('layout changed', this.props.layout, nextProps.layout)
            return true
        }
        if (nextProps.background !== this.props.background) {
            // console.log('background changed', this.props.background, nextProps.background)
            return true
        }
        return false
    }

    renderBottomContent() {
        return (
            <div className={styles.wrapper}>
                <aside className={JoinClassNames([styles.col, styles.aside, styles.aside_news])}>
                    <h3>{this.props.newsHeader}</h3>
                    <News />
                </aside>
                <aside
                    className={JoinClassNames([styles.col, styles.aside, styles.aside_creatives])}
                >
                    <Creatives />
                </aside>
                <footer className={styles.footer}>
                    <LegalTexts />
                </footer>
            </div>
        )
    }

    render() {
        // Get the name of the current layout
        const layout =
            this.props.layout !== undefined ? `login_${this.props.layout}` : 'login_default'

        const inlineStyle = {
            backgroundImage: `url(${this.props.background})`,
        }

        return (
            <div
                className={`${styles.main_section} ${styles[layout]} ${styles[this.props.locale]}`}
                style={inlineStyle}
            >
                <div className={styles.sList}>
                    <div className={styles.serverList}>
                        <ServerMenu />
                    </div>
                    <div className={styles.serverListPadding} />
                </div>
                <Dashboard layout={layout} />
                {this.renderBottomContent()}
                <SideContainer />
            </div>
        )
    }
}

MainSection.propTypes = {
    locale: PropTypes.string,
    layout: PropTypes.string,
    newsHeader: PropTypes.string,
    background: PropTypes.string,
}

MainSection.defaultProps = {
    background: '',
}

export default MainSection



// WEBPACK FOOTER //
// ./src/components/MainSection/main-section.js